
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recent",
      function () {
        return require("private-next-pages/recent/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recent"])
      });
    }
  